/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import { HttpClient } from "./http-client";
export class Api extends HttpClient {
    /**
     * No description
     *
     * @name SetLocale
     * @request POST:/api/locale/{locale}
     * @secure
     */
    setLocale = ({ locale }, params = {}) => this.request({
        path: `/api/locale/${locale}`,
        method: "POST",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @name GetCraSettings
     * @request GET:/api/settings/cra
     * @secure
     */
    getCraSettings = (params = {}) => this.request({
        path: `/api/settings/cra`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name UploadCraTemplate
     * @request PUT:/api/settings/cra/{accountKind}
     * @secure
     */
    uploadCraTemplate = ({ accountKind }, data, params = {}) => this.request({
        path: `/api/settings/cra/${accountKind}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name DeleteCraTemplate
     * @request DELETE:/api/settings/cra/{accountKind}
     * @secure
     */
    deleteCraTemplate = ({ accountKind }, params = {}) => this.request({
        path: `/api/settings/cra/${accountKind}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name GetExportTemplate
     * @request GET:/api/settings/export
     * @secure
     */
    getExportTemplate = (params = {}) => this.request({
        path: `/api/settings/export`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name UploadExportTemplate
     * @request PUT:/api/settings/export
     * @secure
     */
    uploadExportTemplate = (data, params = {}) => this.request({
        path: `/api/settings/export`,
        method: "PUT",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name DeleteExportTemplate
     * @request DELETE:/api/settings/export
     * @secure
     */
    deleteExportTemplate = (params = {}) => this.request({
        path: `/api/settings/export`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name GetUsersInvitations
     * @request GET:/api/users/invitations
     * @secure
     */
    getUsersInvitations = (params = {}) => this.request({
        path: `/api/users/invitations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name CreateUsersInvitation
     * @request PUT:/api/users/invitations
     * @secure
     */
    createUsersInvitation = (data, params = {}) => this.request({
        path: `/api/users/invitations`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name RevokeUsersInvitation
     * @request DELETE:/api/users/invitations
     * @secure
     */
    revokeUsersInvitation = (data, params = {}) => this.request({
        path: `/api/users/invitations`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name GetUsers
     * @request GET:/api/users
     * @secure
     */
    getUsers = (params = {}) => this.request({
        path: `/api/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name UpdateUser
     * @request POST:/api/users/{userId}
     * @secure
     */
    updateUser = ({ userId }, data, params = {}) => this.request({
        path: `/api/users/${userId}`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name DeleteUser
     * @request DELETE:/api/users/{userId}
     * @secure
     */
    deleteUser = ({ userId }, params = {}) => this.request({
        path: `/api/users/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @name GetAssigneesManagersRiskLevelMap
     * @request GET:/api/settings/assignees_managers_risk_level_map
     * @secure
     */
    getAssigneesManagersRiskLevelMap = (params = {}) => this.request({
        path: `/api/settings/assignees_managers_risk_level_map`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name SetAssigneesManagersRiskLevelMap
     * @request POST:/api/settings/assignees_managers_risk_level_map
     * @secure
     */
    setAssigneesManagersRiskLevelMap = (data, params = {}) => this.request({
        path: `/api/settings/assignees_managers_risk_level_map`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name GetOverview
     * @request GET:/api/overview
     * @secure
     */
    getOverview = (query, params = {}) => this.request({
        path: `/api/overview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name SetImportance
     * @request POST:/api/overview/{nodeId}/importance
     * @secure
     */
    setImportance = ({ nodeId }, data, params = {}) => this.request({
        path: `/api/overview/${nodeId}/importance`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name SetAssignedManagers
     * @request POST:/api/overview/{nodeId}/managers
     * @secure
     */
    setAssignedManagers = ({ nodeId }, data, params = {}) => this.request({
        path: `/api/overview/${nodeId}/managers`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name ReviewSegmentDecisionWrite
     * @request PUT:/api/review/segments/decisions
     * @secure
     */
    reviewSegmentDecisionWrite = (data, params = {}) => this.request({
        path: `/api/review/segments/decisions`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name ReviewFormCommentWrite
     * @request PUT:/api/review/form/comment
     * @secure
     */
    reviewFormCommentWrite = (data, params = {}) => this.request({
        path: `/api/review/form/comment`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name ReviewTransition
     * @request POST:/api/review/connection/{connectionId}/transition
     * @secure
     */
    reviewTransition = ({ connectionId }, data, params = {}) => this.request({
        path: `/api/review/connection/${connectionId}/transition`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name ReviewGet
     * @request GET:/api/review/connection/{connectionId}
     * @secure
     */
    reviewGet = ({ connectionId }, params = {}) => this.request({
        path: `/api/review/connection/${connectionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name EntityAssociationsGet
     * @request GET:/api/entity/{entityId}/associations
     * @secure
     */
    entityAssociationsGet = ({ entityId, ...query }, params = {}) => this.request({
        path: `/api/entity/${entityId}/associations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name EntityLookup
     * @request POST:/api/entity/lookup
     * @secure
     */
    entityLookup = (query, data, params = {}) => this.request({
        path: `/api/entity/lookup`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name EntityGet
     * @request GET:/api/entity/{entityId}
     * @secure
     */
    entityGet = ({ entityId }, params = {}) => this.request({
        path: `/api/entity/${entityId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * @description Disconnects an entity from a parent entity
     *
     * @name EntityDisconnectEntity
     * @request DELETE:/api/entity/{parentEntityId}/{connectionKind}/{entityId}
     * @secure
     */
    entityDisconnectEntity = ({ parentEntityId, connectionKind, entityId }, params = {}) => this.request({
        path: `/api/entity/${parentEntityId}/${connectionKind}/${entityId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * @description Use existing entity to connect to parent entity
     *
     * @name EntityConnectExisting
     * @request PUT:/api/entity/{parentEntityId}/{connectionKind}/{entityId}
     * @secure
     */
    entityConnectExisting = ({ parentEntityId, connectionKind, entityId }, data, params = {}) => this.request({
        path: `/api/entity/${parentEntityId}/${connectionKind}/${entityId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * @description Add new entity and connect to parent entity
     *
     * @name EntityConnectNew
     * @request PUT:/api/entity/{parentEntityId}/{connectionKind}/new/{entityKind}
     * @secure
     */
    entityConnectNew = ({ parentEntityId, connectionKind, entityKind }, data, params = {}) => this.request({
        path: `/api/entity/${parentEntityId}/${connectionKind}/new/${entityKind}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name Entities
     * @request GET:/api/entity_observer/entities
     * @secure
     */
    entities = (query, params = {}) => this.request({
        path: `/api/entity_observer/entities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name SegmentsRead
     * @request POST:/api/segments
     * @secure
     */
    segmentsRead = (data, params = {}) => this.request({
        path: `/api/segments`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name SegmentsWrite
     * @request PUT:/api/segments
     * @secure
     */
    segmentsWrite = (data, params = {}) => this.request({
        path: `/api/segments`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name SegmentsBasicInfoRead
     * @request GET:/api/segments/{entityId}/basic
     * @secure
     */
    segmentsBasicInfoRead = ({ entityId }, params = {}) => this.request({
        path: `/api/segments/${entityId}/basic`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name Download
     * @request POST:/api/segments/file
     * @secure
     */
    download = (data, params = {}) => this.request({
        path: `/api/segments/file`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name Upload
     * @request PUT:/api/segments/file
     * @secure
     */
    upload = (data, params = {}) => this.request({
        path: `/api/segments/file`,
        method: "PUT",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name OrderAccountsExport
     * @request POST:/api/export
     * @secure
     */
    orderAccountsExport = (params = {}) => this.request({
        path: `/api/export`,
        method: "POST",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @name ListAccountsExport
     * @request GET:/api/export
     * @secure
     */
    listAccountsExport = (params = {}) => this.request({
        path: `/api/export`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name DownloadAccountsExport
     * @request GET:/api/export/download/{exportId}
     * @secure
     */
    downloadAccountsExport = ({ exportId }, params = {}) => this.request({
        path: `/api/export/download/${exportId}`,
        method: "GET",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @name GetCurrentUserInfo
     * @request GET:/api/auth/me
     * @secure
     */
    getCurrentUserInfo = (params = {}) => this.request({
        path: `/api/auth/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name AdhocSearch
     * @request POST:/api/search/adhoc
     * @secure
     */
    adhocSearch = (data, params = {}) => this.request({
        path: `/api/search/adhoc`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name FeedbackIssue
     * @request POST:/api/feedback/issue
     * @secure
     */
    feedbackIssue = (data, params = {}) => this.request({
        path: `/api/feedback/issue`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name MonitoringSearches
     * @request GET:/api/monitoring
     * @secure
     */
    monitoringSearches = (query, params = {}) => this.request({
        path: `/api/monitoring`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name MonitoringSearchDetailsPdf
     * @request GET:/api/monitoring/{graphNodeId}/pdf
     * @secure
     */
    monitoringSearchDetailsPdf = ({ graphNodeId }, params = {}) => this.request({
        path: `/api/monitoring/${graphNodeId}/pdf`,
        method: "GET",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @name MonitoringSearchCertificatePdf
     * @request GET:/api/monitoring/search/{searchId}/pdf
     * @secure
     */
    monitoringSearchCertificatePdf = ({ searchId }, params = {}) => this.request({
        path: `/api/monitoring/search/${searchId}/pdf`,
        method: "GET",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @name MonitoringSearchAcknowledge
     * @request GET:/api/monitoring/{graphNodeId}/ack
     * @secure
     */
    monitoringSearchAcknowledge = ({ graphNodeId }, params = {}) => this.request({
        path: `/api/monitoring/${graphNodeId}/ack`,
        method: "GET",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @name MonitoringSearchDetails
     * @request GET:/api/monitoring/{graphNodeId}
     * @secure
     */
    monitoringSearchDetails = ({ graphNodeId, ...query }, params = {}) => this.request({
        path: `/api/monitoring/${graphNodeId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name MonitoringSearchMatchCommentCreate
     * @request PUT:/api/monitoring/{graphNodeId}/{matchId}/comment
     * @secure
     */
    monitoringSearchMatchCommentCreate = ({ graphNodeId, matchId }, data, params = {}) => this.request({
        path: `/api/monitoring/${graphNodeId}/${matchId}/comment`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name MonitoringSearchMatchStatusUpdate
     * @request POST:/api/monitoring/{graphNodeId}/status
     * @secure
     */
    monitoringSearchMatchStatusUpdate = ({ graphNodeId }, data, params = {}) => this.request({
        path: `/api/monitoring/${graphNodeId}/status`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name CreateDocumentCheck
     * @request POST:/api/check/document
     * @secure
     */
    createDocumentCheck = (data, params = {}) => this.request({
        path: `/api/check/document`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name CreateLivenessCheck
     * @request POST:/api/check/liveness
     * @secure
     */
    createLivenessCheck = (data, params = {}) => this.request({
        path: `/api/check/liveness`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name LegacyObjectUriBySegmentIdentity
     * @request POST:/api/legacy/segment/objectUri
     * @secure
     */
    legacyObjectUriBySegmentIdentity = (data, params = {}) => this.request({
        path: `/api/legacy/segment/objectUri`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name LegacyObjectUriByNodeId
     * @request GET:/api/legacy/{nodeId}/objectUri
     * @secure
     */
    legacyObjectUriByNodeId = ({ nodeId }, params = {}) => this.request({
        path: `/api/legacy/${nodeId}/objectUri`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name LegacyNodeIdByObjectUri
     * @request GET:/api/legacy/{objectName}/nodeId
     * @secure
     */
    legacyNodeIdByObjectUri = ({ objectName }, params = {}) => this.request({
        path: `/api/legacy/${objectName}/nodeId`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name AppMeta
     * @request GET:/api/app
     * @secure
     */
    appMeta = (params = {}) => this.request({
        path: `/api/app`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name WebhookComplyAdvantage
     * @request POST:/api/webhook/comply_advantage
     * @secure
     */
    webhookComplyAdvantage = (data, params = {}) => this.request({
        path: `/api/webhook/comply_advantage`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name WebhookSumsub
     * @request POST:/api/webhook/sumsub
     * @secure
     */
    webhookSumsub = (data, params = {}) => this.request({
        path: `/api/webhook/sumsub`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name WebhookIdenfy
     * @request POST:/api/webhook/idenfy/{tenantId}/{checkKind}
     * @secure
     */
    webhookIdenfy = ({ tenantId, checkKind }, data, params = {}) => this.request({
        path: `/api/webhook/idenfy/${tenantId}/${checkKind}`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
    });
    /**
     * No description
     *
     * @name Signup
     * @summary Register organization with owner
     * @request POST:/api/signup
     * @secure
     */
    signup = (data, params = {}) => this.request({
        path: `/api/signup`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
}
//# sourceMappingURL=Api.js.map